import { Ref, ref } from "vue";
import { fetchAzimuthFacadeAngle } from "@/api/calculators";

export function useMap(magneticCircleRef: Ref<HTMLElement | null>) {
  const mapCenter = ref<{ lat: number; lng: number } | null>(null);
  const circleAngle = ref(0);

  function endMoveMap(lat: number, lng: number) {
    if (!mapCenter.value) {
      mapCenter.value = { lat, lng };
      updateMagnetNorth();
      return;
    }

    const distance = getDistanceMeters(
      mapCenter.value.lat,
      mapCenter.value.lng,
      lat,
      lng
    );

    if (distance > 10000) {
      mapCenter.value = { lat, lng };
      updateMagnetNorth();
    }
  }

  async function updateMagnetNorth() {
    const wmmResponse = await fetchAzimuthFacadeAngle(
      mapCenter.value?.lat.toString() ?? "0",
      mapCenter.value?.lng.toString() ?? "0"
    );
    const [deg, min] = wmmResponse.split(" ").map(parseFloat);
    const angle = +(deg + min / 60).toFixed(3);
    circleAngle.value = angle;

    if (magneticCircleRef.value) {
      magneticCircleRef.value.style.transform = `translate(-50%, -50%) rotate(${angle}deg)`;
    }
  }

  function getDistanceMeters(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
  ): number {
    const R = 6371000;
    const toRad = (d: number) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  return { circleAngle, endMoveMap };
}
